import React from 'react';
import SurveyResponsePage from '../SurveyResponsePage';
import { useProfiloRappresentante } from './AssociativeCircolari';
import { ShellSondaggi } from './AssociativeSurveys';

/**
 * Compilazione di un sondaggio dall'area associativa: la pagina di risposta
 * del sito con l'identità del rappresentante (Bearer rappresentante, compila
 * come la sua impresa), dentro la shell con la voce «Sondaggi» attiva.
 */
const AssociativeSurveyResponse: React.FC = () => {
  const profile = useProfiloRappresentante();
  return (
    <ShellSondaggi profile={profile}>
      <SurveyResponsePage area="associativa" />
    </ShellSondaggi>
  );
};

export default AssociativeSurveyResponse;
